import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import PopUp from '../../Shared/Popup/PopUp';
import StepsProgressBar from '../../Shared/StepsProgressBar/StepsProgressBar';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';

//store functions
import { initEnergySale, resetBlock, reportDWH, setIsDisplayPopupForHelp } from './energySaleBlockSlice';
import { createWorkOrder } from './energySaleBlockAsyncThunk';
import { resetSalePackagesBlock } from '../SalePackagesBlock/salePackagesBlockSlice';
import PackageBanner from './Partials/PackageBanner/PackageBanner';
import lightIcon from './images/light-icon.svg';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';

//pages
import OtpFormPage from './Pages/OtpFormPage';
import OtpVerifyCodePage from './Pages/OtpVerifyCodePage';
import LoadingPage from './Pages/LoadingPage';
import PackagesPage from './Pages/PackagesPage';
import DigitalSignaturePage from './Pages/DigitalSignaturePage';
import PaymentPage from './Pages/PaymentPage';
import PersonalInfoPage from './Pages/PersonalInfoPage';
import ServiceMessagePage from './Pages/ServiceMessagePage';
import ErrorPage from './Pages/ErrorPage';
import SuccessPage from './Pages/SuccessPage';
import SignatureIframe from './Pages/SignatureIframe';
import { gtag4 } from '../../../utilities/analytics/tracking';

const EnergySale = (props) => {
  let currentView = null;

  //--------------- useEffect ---------------
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      props.initEnergySale({ energySaleBlock: props.iContent, salePackage: props._selectedPackage });
    }
    return () => {
      if (runSideEffects()) {
        props.resetBlock();
        props.resetSalePackagesBlock();
      }
    };
  }, []);

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      if(props.isDisplayPopupForHelp){
        gtag4({
          event: 'Energy_RepContactButton',
          action: 'RepContactButton'
        });
        props.reportDWH({ actionType: 'Help Popup', status: 'Support', messageText: 'PopUp Have a Question - Clicked' })
        gtag4({
          event: 'Energy_ContactPopupImp',
          action: 'ContactPopupImp'
        });
        props.reportDWH({ actionType: 'Help Popup', status: 'Support', messageText: 'PopUp Have a Question - Displayed' })
      }
    }
    return () => {
      if (runSideEffects()) {
      }
    };
  }, [props.isDisplayPopupForHelp]);

  useClearStateResetFlag();

  switch (props.page) {
    case 'otpFormPage': currentView = <OtpFormPage />;  break;
    case 'otpVerifyCodePage' : currentView = <OtpVerifyCodePage />;  break;
    case 'loadingPage': currentView = <LoadingPage />; break;
    case 'packagesPage': currentView = <PackagesPage />; break;
    case 'digitalSignaturePage': currentView = <DigitalSignaturePage />;  break;
    case 'paymentPage': currentView = <PaymentPage />;  break;
    case 'personalInfoPage': currentView = <PersonalInfoPage />;  break;
    case 'serviceMessagePage': currentView = <ServiceMessagePage/>; break;
    case 'errorPage': currentView = <ErrorPage />; break;
    case 'successPage': currentView = <SuccessPage />; break;
    case 'signatureIframe': currentView = <SignatureIframe />; break;
  }

  function onClickPopUpButton(){
    if(props.isWhatsAppActive){
      gtag4({
        event: 'Energy_ContactPopupWaButton',
        action: 'ContactPopupWaButton'
      });
      props.reportDWH({ actionType: 'Help Popup', status: 'Support', messageText: 'PopUp Have a Question - Clicked Whatsapp' })
      const whatsAppLink = "https://wa.me/"+ props.whatsAppServiceNumber;
      window.open(whatsAppLink, '_blank');
    }
    else{
      createWorkOrder();
    }
  }

  async function createWorkOrder(){
    gtag4({
      event: 'Energy_ContactPopupRepButton',
      action: 'ContactPopupRepButton'
    });
    props.reportDWH({ actionType: 'Help Popup', status: 'Support', messageText: 'PopUp Have a Question - Clicked Lead' })
    props.showAppLoader();
    await props.createWorkOrder();
    props.hideAppLoader();
  }

  return (
    <div className='energy-sale-block'>
      { props.page != 'errorPage' && props.stepsList && <StepsProgressBar  currentStep={props.stepsList[props.pageSettings?.step]} steps={props.stepsList} />}
      { props.pageSettings?.displayPackageBanner && <PackageBanner isBigBanner={props.pageSettings?.displayBigBanner} package={props.selectedPackage}/>}
      {currentView}

      <PopUp className='energy-sale-help-popup' showPopUp={props.isDisplayPopupForHelp} onClose={() => props.setIsDisplayPopupForHelp(false)}>
          {props.workOrderSuccess ?
          <div className="is-work-order-success">
            <div className='popup-title'>תודה!</div>
            <div className='popup-sub-title' >נציג יצור איתך קשר בקרוב</div>
          </div> :
          <>
          <Image src={lightIcon} alt='' />
          <div className='popup-title'>יש לך שאלה? נשמח לעזור!</div>
          <div className='popup-sub-title'>ניצור איתך קשר תוך 2 ימי עסקים</div>
          <div className='btn-wrapper'>
          <BtnSubmit
            isBusiness={false}
            text={props.isWhatsAppActive ? 'לנציג אנושי ב-WhatsApp' : 'אשמח שתחזרו אליי'}
            onclick={onClickPopUpButton}
            formid={'energySaleBlock'}
            isDisplayWhatsAppIcon={props.isWhatsAppActive ? true : false}
          />
          {props.isWhatsAppActive && <button className='call-back-btn' onClick={() => {createWorkOrder()}}>אשמח שתחזרו אלי</button>}
          </div>
          </>
          }
      </PopUp>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    page: state.energySaleBlock.page,
    selectedPackage: state.energySaleBlock.selectedPackage,
    pageSettings: state.energySaleBlock.pageSettings,
    isWhatsAppActive: state.energySaleBlock.energySaleBlockData.isWhatsAppActive,
    whatsAppServiceNumber: state.energySaleBlock.energySaleBlockData.whatsAppServiceNumber,
    isDisplayPopupForHelp: state.energySaleBlock.isDisplayPopupForHelp,
    stepsList : state.energySaleBlock.stepsList,
    workOrderSuccess: state.energySaleBlock.workOrderSuccess,
    //other states
    _selectedPackage: state.SalePackagesBlock.selectedPackage,
  };
};

const mapDispatchToProps = { initEnergySale, resetBlock, resetSalePackagesBlock, reportDWH, setIsDisplayPopupForHelp, createWorkOrder, showAppLoader , hideAppLoader };

export default connect(mapStateToProps, mapDispatchToProps)(EnergySale);
